const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const logger = {
    log: (...args) => isDev && console.log(...args),
    warn: (...args) => isDev && console.warn(...args),
    error: (...args) => isDev && console.error(...args),
};

export default logger;